import script from "./home-ztpd.vue?vue&type=script&setup=true&lang=js"
export * from "./home-ztpd.vue?vue&type=script&setup=true&lang=js"

import "./home-ztpd.vue?vue&type=style&index=0&id=0f5589dc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f5589dc"]])

export default __exports__